import { createFileRoute, redirect, useParams } from '@tanstack/react-router';
import { FEATURE_FLAGS } from '@vizit/constants';
import { getFeatureFlag } from '@vizit/feature-flags';
import { ExploreL4Categories } from '../../../../../pages';
import { PagesProvider } from '../../../../../pages/providers/pages-provider';
import { beforeLoadAuthenticatedValidation } from '../../../../../router/route-utils';
import { NavbarPageTemplate } from '../../../../../templates';

export const Route = createFileRoute('/_authenticated/w/$workspaceSlug/explore/$categoryL1')({
  staticData: {
    pageName: 'Select Subcategory',
  },
  beforeLoad: async ({ context, location, params }) => {
    await beforeLoadAuthenticatedValidation(context, location);

    const isClipExperimentEnabled = await getFeatureFlag(FEATURE_FLAGS.TMP_CLIP_EXPERIMENT, false);
    if (isClipExperimentEnabled) {
      throw redirect({ to: '/w/$workspaceSlug/', params: { workspaceSlug: params.workspaceSlug } });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { categoryL1 } = useParams({ from: Route.id });

  return (
    <PagesProvider template={NavbarPageTemplate}>
      <ExploreL4Categories categoryIcp={categoryL1} />
    </PagesProvider>
  );
}
